import DatetimePicker from './DatetimePicker';

export default DatetimePicker;
export { DatetimePicker };
export type { DateTimePickerProps, DatetimePickerType } from './type';
